module.exports = __webpack_public_path__ + "static/media/camping-trip.3a15844c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/DataStewardship/camping-trip.svg
// module id = ./src/DataStewardship/camping-trip.svg
// module chunks = 0